import React, { useState, useEffect } from "react";
import axiosInstance from "../../Request";
import { URL } from "../../api";
import {
  Button,
  FormGroup,
  Label,
  Input,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const AddPayment = () => {
  const { cid, lid } = useParams(); // customerId and leadId from URL

  const [paymentTypes, setPaymentTypes] = useState([]);
  const [loanIds, setLoanIds] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [selectedLoanId, setSelectedLoanId] = useState("");
  const [tranAmount, setTranAmount] = useState("");
  const [transactionDate] = useState(new Date()); // Locked to current date
  const [loading, setLoading] = useState(false);
  const [flag, setFlag] = useState("");
  const [amountDisabled, setAmountDisabled] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [commentBy, setCommentBy] = useState("");
  const [selectedLoanIds, setSelectedLoanIds] = useState([]);

  useEffect(() => {
  const isRollback = selectedType === "RollBack Adjsutment";
  const isForeclosureFlag = flag === 2 || flag === 3 || flag === 1;

  if (isRollback || isForeclosureFlag) {
    setAmountDisabled(true);
  } else {
    setAmountDisabled(false);
  }
}, [selectedType, flag]);



  useEffect(() => {
    const uid = localStorage.getItem("user_id");
    if (uid) {
      setCommentBy(Number(uid));
    } else {
      console.warn("user_id not found in localStorage");
    }
  }, []);

  useEffect(() => {
    const fetchPaymentTypes = async () => {
      try {
        const res = await axiosInstance.get(URL.PAYMENT_LIST);
        setPaymentTypes(res.data || []);
      } catch (error) {
        toast.error("Failed to load payment types.");
      }
    };
    fetchPaymentTypes();
  }, []);
  useEffect(() => {
  const fetchLoans = async () => {
    if (!selectedType || !cid) return;
    try {
      const res = await axiosInstance.get(`${URL.PAYMENT_LOANS}?customerId=${cid}`);
      const loanData = res.data || [];
      setLoanIds(loanData);

      if (loanData.length > 0) {
     
        setSelectedLoanIds([String(loanData[0])]);
      }
    } catch (error) {
      toast.error("Failed to load loans.");
    }
  };
  fetchLoans();
}, [selectedType, cid]);


const handleFlagChange = async (value) => {
  setFlag(value);
  setTranAmount("");
  setAmountDisabled(false);

  if (selectedLoanIds.length === 0) {
    toast.warn("Please select at least one Loan ID.");
    return;
  }

  try {
    const res = await axiosInstance.get(
      `${URL.FORECLOSURE_SUMMARY}?customerId=${cid}&loanIds=${selectedLoanIds.join(",")}`
    );
    const data = res.data;

 
    if (selectedType === "RollBack Adjsutment") {
      const rollbackAmount = data.all_rollback_total_amount || 0;
      const rollbackTrans = data.all_rollback_payments || [];

      if (rollbackAmount === 0 || rollbackTrans.length === 0) {
        toast.warning("No rollback eligible payments found.");
        setTranAmount("");
        return;
      }

      // Save rollback tran_ids for later
      setFlag({
        value,
        rollbackTranIds: rollbackTrans.map((item) => item.tran_id),
      });

      // For flag 2 or 3: Compare rollback with foreclosure amount
      if (value === 2 || value === 3) {
        const relevantAmounts = Object.values(data)
          .filter((v) => typeof v === "object" && !Array.isArray(v))
          .map((summary) =>
            value === 2
              ? summary.foreclosure_total_amount || 0
              : summary.force_foreclosure_total_amount || 0
          );

        const totalActual = relevantAmounts.reduce((a, b) => a + b, 0);

        if (totalActual === 0) {
          toast.warning("Foreclosure(s) already done or not eligible.");
          setTranAmount("");
          return;
        }

        if (rollbackAmount < totalActual) {
          toast.warning(
            `Rollback amount (${rollbackAmount}) is less than required (${totalActual.toFixed(
              2
            )}).`
          );
          setTranAmount("");
          return;
        }
      }

      // For flag 1 (Normal) or valid 2/3: auto-fill and disable
      setTranAmount(rollbackAmount.toFixed(2));
      setAmountDisabled(true);
      return;
    }

    // Fallback: normal foreclosure and force-foreclosure
    if (value === 2 || value === 3) {
      const amounts = Object.values(data)
        .filter((v) => typeof v === "object" && !Array.isArray(v))
        .map((summary) =>
          value === 2
            ? summary.foreclosure_total_amount || 0
            : summary.force_foreclosure_total_amount || 0
        );

      const totalAmount = amounts.reduce((a, b) => a + b, 0);

      if (totalAmount === 0) {
        toast.warning("Foreclosure(s) already done or not eligible.");
        setTranAmount("");
      } else {
        setTranAmount(totalAmount.toFixed(2));
        setAmountDisabled(true);
      }
    }
  } catch (error) {
    console.error(error);
    toast.error("Failed to fetch foreclosure summary");
  }
};



 const handleSubmit = () => {
  if (!selectedType || !tranAmount || !selectedLoanIds) {
    toast.warn("Please fill all fields.");
    return;
  }

  const parsedAmount = parseFloat(tranAmount);
  if (isNaN(parsedAmount) || parsedAmount <= 0) {
    toast.warn("Please enter a valid amount greater than 0.");
    return;
  }

  if (!commentBy) {
    toast.error("User ID not found in localStorage.");
    return;
  }

  setModalOpen(true);
};


  const handleSend = async () => {
  if (!commentText) {
    toast.warn("Please enter a comment.");
    return;
  }

  const parsedAmount = parseFloat(tranAmount);
  if (isNaN(parsedAmount) || parsedAmount <= 0) {
    toast.warn("Please enter a valid amount greater than 0.");
    return;
  }

  let tranIdVal = String(Date.now());
  let flagVal = flag;

  if (selectedType === "RollBack Adjsutment" && flag?.rollbackTranIds) {
    tranIdVal = JSON.stringify(flag.rollbackTranIds);
    flagVal = typeof flag === "object" ? flag.value : flag;
 // extract just the numeric flag
  }

  const payload = {
    paymentType: selectedType,
    paymentAmount: parsedAmount,
    customerId: Number(cid),
    loanId: selectedLoanIds.map(Number),
    service: "Manual",
    tranDate: transactionDate.toISOString().split("T")[0],
    tranId: tranIdVal,
    offerId: 0,
    flag: flagVal,
    comment: commentText,
    commentBy: Number(commentBy),
  };

  try {
    setLoading(true);
    const res = await axiosInstance.post(URL.PAYMENT_AND_COMMENT, payload);
    toast.success(res.data.message || "Payment and comment submitted!");

    // Reset form
    setSelectedType("");
    setSelectedLoanId("");
    setTranAmount("");
    setCommentText("");
    setModalOpen(false);
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("Failed to submit payment and comment.");
  } finally {
    setLoading(false);
  }
};


  return (
    <Container className="mt-4">
      <FormGroup style={{ maxWidth: "300px" }}>
        <Label for="paymentType">Select Payment Type</Label>
        <Input
          type="select"
          id="paymentType"
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
        >
          <option value="">-- Select --</option>
          {paymentTypes.map((type, index) => (
            <option key={index} value={type.statusValue}>
              {type.statusValue}
            </option>
          ))}
        </Input>
      </FormGroup>

      {selectedType && (
        <>
        <FormGroup style={{ maxWidth: "300px" }}>
          <Label for="loanId">Select Loan ID</Label>
         <Input
            type="select"
            id="loanId"
            multiple
            value={selectedLoanIds}
            onClick={(e) => {
              const clickedValue = e.target.value;
              setSelectedLoanIds((prev) =>
                prev.includes(clickedValue)
                  ? prev.filter((id) => id !== clickedValue)
                  : [...prev, clickedValue]
              );
            }}
            >
            {loanIds.map((id) => (
              <option key={id} value={id}>
                {id}
              </option>
            ))}
          </Input>
          <small className="text-muted">Hold Ctrl (Windows) to select multiple</small>
        </FormGroup>
        <FormGroup style={{ maxWidth: "300px" }}>
          <Label>Select Payment Flag</Label>
          <Input
            type="select"
            value={flag}
            onChange={(e) => handleFlagChange(Number(e.target.value))}
          >
            <option value="">--Select Action--</option>
            <option value={1}>Normal Payment</option>
            <option value={2}>Foreclosure Payment</option>
            <option value={3}>Force Foreclosure Payment</option>
          </Input>
        </FormGroup>

          <FormGroup style={{ maxWidth: "300px" }}>
            <Label for="tranAmount">Payment Amount</Label>
            <Input
              type="text"
              id="tranAmount"
              value={tranAmount}
              disabled={amountDisabled}
              onChange={(e) => {
                const val = e.target.value;
                // Accept only valid decimal numbers (up to 2 decimal places)
                if (/^\d*\.?\d{0,2}$/.test(val)) {
                  setTranAmount(val);
                }
              }}
              placeholder="Enter amount"
            />
          </FormGroup>

          <FormGroup style={{ maxWidth: "300px" }}>
            <Label>Transaction Date</Label>
            <DatePicker
              selected={transactionDate}
              onChange={() => {}}
              dateFormat="yyyy-MM-dd"
              className="form-control"
              disabled
            />
          </FormGroup>

          <Button
            color="primary"
            onClick={handleSubmit}
            disabled={loading}
            style={{ maxWidth: "300px" }}
          >
            {loading ? "Submitting..." : "Submit"}
          </Button>
        </>
      )}

      {/* Modal for comment */}
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)}>
        <ModalHeader toggle={() => setModalOpen(!modalOpen)}>Add Comment</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="commentText">Comment</Label>
            <Input
              type="textarea"
              id="commentText"
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
              placeholder="Enter your comment"
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSend} disabled={loading}>
            {loading ? "Sending..." : "Send"}
          </Button>
          <Button color="secondary" onClick={() => setModalOpen(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

export default AddPayment;
